module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/fast-internet-c53c3636fe944bc93d7926348abb6eec.webp";